/**
 *  Tv - channels plugin or system module implementation
 */

'use strict';
var provider;


if ( MODE_STALKER ) {
    provider = require('./stalker');
} else if ( MODE_PORTAL ) {
    provider = require('./portal');
}

module.exports = {
    onAppInit: provider,
    onInit: function ( config, callback ) {
        // dome some operations
        callback();
    },
    onSettingsInit: function ( config, callback ) {
        // dome some operations
        callback(null, settingsData);
    },
    onContentBoardInit: function ( dump, done ) {
        provider.getLauncherProvider(dump.api, function ( data ) {
            done(data);
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 1
// module chunks = 0